import { EventsService } from "@/api/events";
import EventCard, { EventCardProps } from "@/components/EventCard";
import EventsPageLoader from "@/components/SkeletonLoaders/EventsPageLoader";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { getCurrentClientData } from "@/services/authServices";
import { Plus } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";

const mockEvents = [
  {
    id: "evt-1",
    title: "Annual Tech Conference",
    date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString(),
    time: "09:00 AM - 05:00 PM",
    attendees: 65,
    maxAttendees: 100,
    location: "San Francisco, CA",
    description: "Join us for the latest trends and innovations in technology.",
    image:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80",
    price: "Free",
    category: "Technology",
    isDigital: true,
  },
  {
    id: "evt-2",
    title: "Startup Networking Mixer",
    date: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toLocaleDateString(),
    time: "06:30 PM - 09:00 PM",
    attendees: 42,
    maxAttendees: 50,
    location: "New York, NY",
    description:
      "Connect with other entrepreneurs and investors in a casual setting.",
    image:
      "https://images.unsplash.com/photo-1551818255-e6e10975bc17?auto=format&fit=crop&w=800&q=80",
    price: "$15",
    category: "Networking",
  },
  {
    id: "evt-3",
    title: "Product Launch Party",
    date: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000).toLocaleDateString(),
    time: "07:00 PM - 10:00 PM",
    attendees: 17,
    maxAttendees: 75,
    location: "Austin, TX",
    description: "Be the first to experience our revolutionary new product.",
    image:
      "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=800&q=80",
    price: "$25",
    category: "Product",
  },
];

const EventsTab = () => {
  const { toast } = useToast();
  const { getEvents } = EventsService;
  const loggedInUser = getCurrentClientData();
  const [loading, setLoading] = useState(true);
  const [eventsList, setEventsList] = useState([]);

  useEffect(() => {
    if (loggedInUser) {
      loadAllEventsFn();
    } else {
      setLoading(false);
    }
  }, []);

  const loadAllEventsFn = async () => {
    setLoading(true);

    try {
      const res: any = await getEvents(loggedInUser?.token);

      if (res.statusCode === 200 || res.statusCode === 201) {
        setEventsList(res.body.events);
      } else {
        toast({
          title: "Error",
          description:
            res.body.message || "There was an error creating your event.",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "There was an error creating your event.",
        variant: "destructive",
      });
      return;
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <EventsPageLoader />;
  }
  const eventsToRender = loggedInUser
    ? eventsList.map((event) => ({
        id: event.event_id,
        title: event.event_title,
        description: event.event_description,
        date: new Date(event.event_date).toLocaleDateString(),
        time: `${event.start_time} - ${event.end_time}`,
        location: event.location,
        image: event.img_url?.[0],
        attendees: 0, // default until backend supports it
        // maxAttendees: event.max_attendees,
        price: `$${event?.ticket_price ?? "0"}`,
        category: event.category,
        isDigital: event.virtual_event,
      }))
    : mockEvents;
  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">All Events</h2>
        <Link to="/create">
          <Button>
            <Plus className="h-4 w-4 mr-1" /> Create Event
          </Button>
        </Link>
      </div>
      {eventsToRender.length > 0 ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* {eventsToRender.map((event) => (
          <EventCard
            key={event.id}
            {...(event as EventCardProps)}
            actions={
              event.isDigital
                ? [
                    {
                      label: "Join Digital Event",
                      href: `/digital-event/${event.id}`,
                      primary: true,
                    },
                    { label: "Manage", href: `/dashboard/${event.id}` },
                  ]
                : undefined
            }
          />
        ))} */}

          {eventsToRender.map((event) => (
            <EventCard
              key={event.id}
              {...(event as EventCardProps)}
              actions={
                event.virtual_event === "Yes"
                  ? [
                      {
                        label: "Join Digital Event",
                        href: `/digital-event/${event.id}`,
                        primary: true,
                      },
                      { label: "Manage", href: `/dashboard/${event.id}` },
                    ]
                  : [
                      {
                        label: "Manage",
                        href: `/dashboard/${event.id}`,
                        primary: true,
                      },
                    ]
              }
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-12 justify-center items-center flex flex-col">
          <Calendar className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900">No events found</h3>
        </div>
      )}
    </>
  );
};

export default EventsTab;
